import { Component, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';

@Component({
    selector: 'app-auth-expired-modal',
    imports: [CommonModule, FontAwesomeModule, LoadingButtonComponent],
    template: `
    <div class="modal-header">
      <h4 class="modal-title">Session Expired</h4>
    </div>
    <div class="modal-body text-center">
      <p><fa-icon [icon]="faExclamationTriangle" class="text-warning"></fa-icon> Your session has expired. Please log in again to continue.</p>
    </div>
    <div class="modal-footer justify-content-center">
      <app-loading-button
        [loading]="isLoading()"
        [disabled]="false"
        (buttonClick)="login()">
        Log In
      </app-loading-button>
    </div>
  `
})
export class AuthExpiredModalComponent {
  protected activeModal = inject(NgbActiveModal);
  protected faExclamationTriangle = faExclamationTriangle;
  private router = inject(Router);
  protected isLoading = signal<boolean>(false);

  login(): void {
    this.isLoading.set(true);
    const currentRoute = this.router.url;
    // Redirect to the catalog authorization URL with the current route as action
    const authUrl = `${environment.catalogUrl}/api/authorization/request?targetApp=admin-ui&action=${encodeURIComponent(currentRoute)}`;
    window.location.href = authUrl;
  }
}
